import React from "react";

const CryptoHuntTile = ({ char, className, index }) => {
  return (
    <div
      style={{
        transition: "background-color 0.3s ease, opacity 0.3s ease",
        opacity: 0,
        animation: `fadeIn 0.3s ease forwards ${index * 0.3}s`,
      }}
      className={`${className} border-2 border-[#434343] xl:h-20 xs:h-[72px] h-[60px] xl:w-20 xs:w-[72px] w-[60px] xl:text-[40px] xs:text-2xl text-xl text-center font-bold font-redHat text-white bg-[#000]  cursor-pointer transition-all duration-250 ease flex flex-col items-center justify-center  rounded-[10px]`}
    >
      {char}
    </div>
  );
};

export default CryptoHuntTile;

const styles = document.createElement("style");
styles.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
document.head.appendChild(styles);
